globalThis.PlayerConfiguration = class PlayerConfiguration {
  constructor() {
    this.index = 0;
  }

  static ofKeys(left, down, up, right, index) {
    const config = new PlayerConfiguration();
    config.left_key = left;
    config.down_key = down;
    config.up_key = up;
    config.right_key = right;
    config.index = index || 0;
    return config;
  }
};
